// hooks/useDebouncedCallbackPerKey.ts
import { debounce } from 'lodash';
import { useRef, useState } from 'react';
function useDebouncedCallbackPerKey(callback, delay) {
    const debounceMap = useRef(new Map());
    const [savingKeys, setSavingKeys] = useState(new Set());
    const debouncedCallback = (key, value) => {
        var _a;
        setSavingKeys((prev) => new Set(prev).add(key));
        if (!debounceMap.current.has(key)) {
            const debounced = debounce((k, v) => {
                Promise.resolve(callback(k, v)).finally(() => {
                    setSavingKeys((prev) => {
                        const next = new Set(prev);
                        next.delete(k);
                        return next;
                    });
                });
            }, delay);
            debounceMap.current.set(key, debounced);
        }
        (_a = debounceMap.current.get(key)) === null || _a === void 0 ? void 0 : _a(key, value);
    };
    return [debouncedCallback, savingKeys];
}
export default useDebouncedCallbackPerKey;
